import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Insurance Sales' }]

const CareersPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>{' '}
		&rarr;{' '}
		<Link to="/careers/" prefetch="intent" className="text-blue-600 underline">
			Careers
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">Insurance Sales</h1>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			<h3>Job Description</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We are seeking energetic and driven individuals with an entrepreneurial
				spirit to join our sales department. As an independent insurance
				professional you will work with a dynamic team of sales agents that
				share your desire to win. Position pays a competitive base with a
				generous commission structure that works well for those who are
				disciplined and follow our proven sales process.
			</p>
			<h3>Job Responsibilities</h3>
			<ul>
				<li>Maintain knowledge of products</li>
				<li>
					Prospect and generate new business through personal contacts &
					referral sources
				</li>
				<li>Be outstanding at relationship building</li>
				<li>
					Present and explain insurance policy options based upon prospective
					client needs
				</li>
			</ul>
			<h3>Job Requirements</h3>
			<ul>
				<li>Exhibit professional phone and interpersonal etiquette</li>
				<li>
					Possess, or be able to obtain, a property & casualty insurance license
				</li>
				<li>
					Display leadership competencies, including the ability to engage and
					inspire others
				</li>
				<li>Possess strong work ethic and leadership skills</li>
				<li>Model driven and goal-oriented behavior</li>
				<li>Demonstrate strong communication and negotiation skills</li>
			</ul>
			<br />
			Send an email with your resume and cover letter to{' '}
			<a href="mailto:careers@steeleagency.com">careers@steeleagency.com</a> to
			start the application process.
		</p>
	</main>
)

export default CareersPage
